import { render } from "./BudgetPercentage.vue?vue&type=template&id=8b8bb54c&scoped=true"
import script from "./BudgetPercentage.vue?vue&type=script&lang=js"
export * from "./BudgetPercentage.vue?vue&type=script&lang=js"

import "./BudgetPercentage.vue?vue&type=style&index=0&id=8b8bb54c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8bb54c"]])

export default __exports__